module.exports = __webpack_public_path__ + "img/more_services_entry.470df405.png";